import type React from 'react';

import {
  SkeletonProfileImage,
  SkeletonImage,
  SkeletonBody,
} from '@xing-com/skeleton';

import { CompanyCardContainer } from '../company-card-container';
import * as Styled from './skeleton.styles';

const CompanyCardSkeletonLoggedin: React.FC = () => (
  <Styled.SkeletonWrapper
    data-testid="skeleton-logged-in"
    className="skeletonWrapperLoggedIn"
  >
    <div>
      <Styled.RelativeWrapper>
        <SkeletonImage size="large" height="140px" />
        <Styled.AbsoluteWrapper>
          <SkeletonProfileImage variant="primary" size="large" />
        </Styled.AbsoluteWrapper>
      </Styled.RelativeWrapper>
      <Styled.SkeletonProfileInfo>
        <SkeletonBody variant="primary" amountRows={2} />
      </Styled.SkeletonProfileInfo>
    </div>
    <Styled.SkeletonButton />
  </Styled.SkeletonWrapper>
);

const CompanyCardsSkeletonLoggedin = () => (
  <CompanyCardContainer dataTestId="loggedin-skeleton-row">
    <CompanyCardSkeletonLoggedin />
    <CompanyCardSkeletonLoggedin />
    <CompanyCardSkeletonLoggedin />
  </CompanyCardContainer>
);
export { CompanyCardsSkeletonLoggedin };
